import {resolvePhase} from './guides/rules.mjs';

// Use catalogue identities or the explicit manual relation, never title guesses.
export function guideForPlant(category,manual,guides) {
  return guides.find(g=>g.slug===category?.slug)
    || guides.find(g=>g.slug===manual?.category?.slug)
    || null;
}

export function plantGuidePhase(guide,selected,context={}) {
  if(!guide?.phases?.length)return null;
  const index=Math.max(0,guide.phases.findIndex(p=>[p.urlId,p.id,p.alias].includes(selected)));
  const phase=resolvePhase(guide.phases[index],context);
  const nextId=(phase.skipped&&phase.skipTo)||phase.nextUrl||guide.phases[index+1]?.urlId;
  const next=guide.phases.find(p=>[p.urlId,p.id,p.alias].includes(nextId));
  return {...phase,next:next||null};
}

export function plantGuideLink(guide,phase) {
  return '/manuals/'+encodeURIComponent(guide.slug)+(phase?'?phase='+encodeURIComponent(phase.urlId):'');
}
